const JSONStreamEvent = 'json-stream-received'
const STREAM_AS_PROMISE = Symbol('STREAM_AS_PROMISE')
const incompleteMessagesState = {}
export function useStream (bus) {
  function emitJSON (payload = {}) {
    let { data, eventID, stateID, fromIncomplete } = payload
    eventID = eventID || ''
    if (typeof data === 'undefined') {
      bus.$emit(getStreamEventName(eventID), data)
      return data
    }
    const jsonString = Buffer.from(data).toString('utf8')
    try {
      const parsedData = JSON.parse(jsonString)
      if (bus) {
        bus.$emit(getStreamEventName(eventID), parsedData)
      }
      if (fromIncomplete && incompleteMessagesState[stateID] && incompleteMessagesState[stateID].startsWith(jsonString)) {
        incompleteMessagesState[stateID] = incompleteMessagesState[stateID].substring(jsonString.length)
      }
      return parsedData
    } catch (e) {
      console.debug(e, jsonString)
      const data = []
      const unprocessed = splitJSON(jsonString)
      splitJSON(jsonString).every((jsonStringPart) => {
        try {
          const parsedData = JSON.parse(jsonStringPart)
          if (bus) {
            bus.$emit(getStreamEventName(eventID), parsedData)
          }
          data.push(parsedData)
          unprocessed.shift()
          if (incompleteMessagesState[stateID] && incompleteMessagesState[stateID].startsWith(jsonStringPart)) {
            incompleteMessagesState[stateID] = incompleteMessagesState[stateID].substring(jsonStringPart.length)
          }
        } catch (e) {
          console.debug(e)
          const unprocessedString = unprocessed.join('')
          if (incompleteMessagesState[stateID] !== unprocessedString) {
            incompleteMessagesState[stateID] = incompleteMessagesState[stateID] || ''
            incompleteMessagesState[stateID] += unprocessedString
          }
          return false
        }
        return true
      })
      return data
    }
  }

  function getStreamEventName (id) {
    return JSONStreamEvent + '/' + id
  }

  function asString (data) {
    return Buffer.from(data).toString('utf8')
  }

  function processIncompleteMessages (data, eventID, stateID, callback, transformFunction) {
    transformFunction = typeof transformFunction === 'function' ? transformFunction : asString
    const transformedData = transformFunction(data)
    if (incompleteMessagesState[stateID] && incompleteMessagesState[stateID] !== transformedData) {
      const data = incompleteMessagesState[stateID]
      try {
        return callback({ data, eventID, stateID, fromIncomplete: true })
      } catch (e) {
        console.error(e)
      }
    }
  }

  async function fetchStream (url, options = {}, callback) {
    callback = callback || emitJSON
    // eslint-disable-next-line no-undef
    const controller = new AbortController()
    const stateID = Symbol('stateID')
    const eventID = options.eventID || options.endpoint
    const fetchOptions = options.fetch || options
    fetchOptions.signal = fetchOptions.signal || controller.signal
    try {
      if (options.before && typeof options.before === 'function') {
        options.before(controller)
      }
      const response = await fetch(url, fetchOptions)
      const reader = response.body.getReader()
      const results = []
      let value, done
      while (true) {
        ({ value, done } = await reader.read())
        if (done) break
        switch (true) {
          case typeof callback === 'function':
            callback({ data: value, eventID, stateID })
            processIncompleteMessages(value, eventID, stateID, callback, options.transformFucntion)
            break
          case callback === STREAM_AS_PROMISE: {
            const result = emitJSON({ data: value, eventID: '', stateID })
            const resultFromCompleted = processIncompleteMessages(value, '', stateID, emitJSON, options.transformFucntion)
            if (result) {
              if (Array.isArray(result)) {
                results.push(...result)
              } else {
                results.push(result)
              }
            }
            if (resultFromCompleted) {
              if (Array.isArray(resultFromCompleted)) {
                results.push(...resultFromCompleted)
              } else {
                results.push(resultFromCompleted)
              }
            }
          }
        }
      }
      if (typeof callback === 'function' && response.status !== 200) {
        callback({ data: value, eventID, stateID })
      }
      return results.length === 1 ? results[0] : results
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error(error)
        throw error
      }
    } finally {
      delete incompleteMessagesState[stateID]
    }
  }
  return {
    emitJSON,
    fetchStream,
    getStreamEventName,
    STREAM_AS_PROMISE
  }
}

const joinedJSONDelimiters = /(}{|}\[|]\[|]{)/g

function splitJSON (jsonString) {
  let elements = jsonString.split(joinedJSONDelimiters)
  if (elements.length === 1) return elements

  const delimiters = elements.filter(item => item.match(joinedJSONDelimiters))
  elements = elements.filter(item => !item.match(joinedJSONDelimiters))
  return elements.map((item, index) => {
    switch (index) {
      case 0:
        return item + delimiters[index][0]
      case elements.length - 1:
        return delimiters[index - 1][1] + item
      default:
        return delimiters[index - 1][1] + item + delimiters[index][0]
    }
  })
}



// WEBPACK FOOTER //
// ./src/commons/stream.js